module.exports = __webpack_public_path__ + "static/img/qrcode.34f3e7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode.jpg
// module id = TUKC
// module chunks = 73